<template>
  <v-card outlined class="backoffice-table" style="box-shadow: none !important">
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      hide-default-footer
      @page-count="pageCount = $event"
      @update:page="requestPage($event)"
      class="elevation-1"
      :loading="loading"
      :mobile-breakpoint="0"
    >
      <!-- TOP -->
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <!-- Select Sports -->
          <v-select
            :items="sportsList"
            v-model="selectedSport"
            :class="selectedSport"
            placeholder="Modalidade"
            hide-details
            background-color="#D8E0E6"
            color="#9aabb8"
            solo
            flat
            height="32px"
          ></v-select>
          <!-- Select Sports -->
          <v-select
            :items="countriesList"
            v-model="selectedCountry"
            :class="selectedCountry"
            placeholder="País"
            hide-details
            background-color="#D8E0E6"
            color="#9aabb8"
            solo
            flat
            height="32px"
          ></v-select>
          <v-spacer></v-spacer>
          <!-- Search -->
          <v-text-field
            class="search-feild"
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Pesquisar por"
            dense
            solo
            flat
            filled
            hide-details
            clearable
            @keydown.enter="getItems(0, itemsPerPage)"
          ></v-text-field>
          <!-- Create/Edit Dialog -->
          <v-dialog
            v-model="dialog"
            :max-width="editedItem.matchMarkets.length > 1 ? '800px' : '600px'"
            content-class="backoffice-dialog"
            scrollable
          >
            <!-- Dialog Button -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                height="40"
                v-bind="attrs"
                v-on="on"
                @click="
                  editedItem = $lodash.cloneDeep(simpleItem);
                  isMultiple = false;
                  tempItem = {};
                  dialogTitle = 'Adicionar prognóstico';
                "
                >Adicionar prognóstico</v-btn
              >
            </template>
            <v-card>
              <!-- style="overflow-y: scroll; height: 600px" -->
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="
                    dialog = false;
                    editedItem = $lodash.cloneDeep(simpleItem);
                  "
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Input text fields -->
              <v-row style="overflow-y: auto">
                <v-col cols="12" class="dialog-frame">
                  <div class="dialog-title">{{ dialogTitle }}</div>
                  <!-- TiroCerteiro -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="editedItem.tiroCerteiro"
                        label="Tiro Certeiro"
                        class="dialog-switch"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <!-- IsMultiple -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="isMultiple"
                        label="Múltiplo"
                        class="dialog-switch"
                        @click="setMultiple()"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-for="(value, index) in editedItem.matchMarkets"
                      :key="'matchMarket-' + value.id + index"
                    >
                      <!-- Sport & Country -->
                      <v-row>
                        <v-col cols="6">
                          <div class="dialog-label">Modalidade</div>
                          <v-select
                            @input="
                              updateCompetitionsAndMarkets(
                                value.match.country,
                                value.match.sport,
                                index
                              );
                              validateInput('sport', input.sport[index], true);
                            "
                            :items="sports"
                            item-text="name"
                            item-value="id"
                            v-model="value.match.sport"
                            background-color="#D8E0E6"
                            color="#9aabb8"
                            solo
                            flat
                            height="32px"
                            :hide-details="!input.sport[index].error"
                            :error-messages="input.sport[index].errorText"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <div class="dialog-label">País</div>
                          <v-select
                            @input="
                              getCompetitionList(
                                value.match.country,
                                value.match.sport,
                                index
                              );
                              validateInput('country', input.country[index], true);
                            "
                            :items="countries"
                            item-text="name"
                            item-value="id"
                            v-model="value.match.country"
                            background-color="#D8E0E6"
                            color="#9aabb8"
                            solo
                            flat
                            height="32px"
                            :hide-details="!input.country[index].error"
                            :error-messages="input.country[index].errorText"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <!-- Competition -->
                      <v-row>
                        <v-col>
                          <div class="dialog-label">Competição</div>
                          <v-select
                            @input="
                              getMatchesList(value.match.competition, index);
                              validateInput(
                                'competition',
                                input.competition[index],
                                true
                              );
                            "
                            :items="competitions[index]"
                            item-text="name"
                            item-value="id"
                            v-model="value.match.competition"
                            background-color="#D8E0E6"
                            color="#9aabb8"
                            solo
                            flat
                            height="32px"
                            :hide-details="!input.competition[index].error"
                            :error-messages="input.competition[index].errorText"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <!-- MATCHES -->
                      <v-row>
                        <v-col>
                          <div class="dialog-label">Jogo</div>
                          <v-select
                            @input="validateInput('id', input.match[index], true)"
                            :items="matches[index]"
                            item-value="id"
                            v-model="value.match.id"
                            class="prognostic-match"
                            background-color="#FFFFFF"
                            color="#9aabb8"
                            solo
                            flat
                            height="80"
                            :menu-props="{
                              contentClass: 'prognostic-match-menu',
                            }"
                            :hide-details="!input.match[index].error"
                            :error-messages="input.match[index].errorText"
                          >
                            <template v-slot:selection="{ item }">
                              <div>{{ item.date }} | {{ item.hour }}</div>
                              <div>
                                {{ item.homeTeam.name }} x
                                {{ item.awayTeam.name }}
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <div>
                                <div>{{ item.date }} | {{ item.hour }}</div>
                                <div>
                                  {{ item.homeTeam.name }} x
                                  {{ item.awayTeam.name }}
                                </div>
                              </div>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                      <!-- BETS -->
                      <div
                        v-for="(market, index) in value.bigoddsMarkets"
                        :key="'bigoddsMarket-' + market.id + index"
                      >
                        <v-row>
                          <v-col cols="6">
                            <div class="dialog-label">Mercado</div>
                            <v-select
                              :items="markets"
                              item-text="name"
                              return-object
                              v-model="value.bigoddsMarkets[index].market"
                              hide-details
                              background-color="#D8E0E6"
                              color="#9aabb8"
                              solo
                              flat
                              height="32px"
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <div class="dialog-label">Resultado</div>
                            <v-select
                              :items="
                                value.bigoddsMarkets[index].market
                                  ? value.bigoddsMarkets[index].market.outcomes
                                  : value.bigoddsMarkets[index].outcomes
                              "
                              item-text="name"
                              v-model="value.bigoddsMarkets[index].outcome"
                              hide-details
                              background-color="#D8E0E6"
                              color="#9aabb8"
                              solo
                              flat
                              height="32px"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="3">
                            <div class="dialog-label">Odd</div>
                            <v-text-field
                              class="dialog-text"
                              dense
                              filled
                              hide-details
                              v-model="value.bigoddsMarkets[index].odd"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <div class="dialog-label">% Banca</div>
                            <v-text-field
                              class="dialog-text"
                              dense
                              filled
                              hide-details
                              v-model="value.bigoddsMarkets[index].bank"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-divider
                          style="margin-top: 16px; margin-bottom: 8px"
                        ></v-divider>
                      </div>
                      <v-row>
                        <v-col>
                          <v-btn
                            depressed
                            dark
                            color="#9AABB8"
                            @click="addMarket(value.bigoddsMarkets)"
                            >+ Adicionar mercado</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="validate(false)"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Close Prognostic Dialog -->
          <v-dialog
            v-model="closePrognostic"
            max-width="800"
            content-class="backoffice-dialog"
          >
            <v-card>
              <!-- style="overflow-y: scroll; height: 600px" -->
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="
                    closePrognostic = false;
                    editedItem = $lodash.cloneDeep(simpleItem);
                  "
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Input text fields -->
              <v-row>
                <v-col cols="12" class="dialog-frame">
                  <div class="dialog-title">Encerrar prognóstico</div>
                  <v-row
                    v-for="(value, index) in editedItem.matchMarkets"
                    :key="'closeMarket-' + value.id + index"
                  >
                    <v-col>
                      <!-- TEAMS -->
                      <v-row v-if="value.match.homeTeam">
                        <!-- Team Logos -->
                        <v-col class="team-logos" cols="12">
                          <div class="logos-container">
                            <v-list-item-avatar
                              class="team-icon"
                              size="72"
                              style="z-index: 1"
                            >
                              <v-img
                                :src="value.match.homeTeam.image"
                                aspect-ratio="1"
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-avatar class="team-icon" size="72">
                              <v-img
                                :src="value.match.awayTeam.image"
                                aspect-ratio="1"
                              ></v-img>
                            </v-list-item-avatar>
                          </div>
                        </v-col>
                        <!-- Date and Time -->
                        <v-col class="match-details" cols="12">
                          <v-list-item style="padding: 0">
                            <v-list-item-content style="padding: 0">
                              <v-list-item-subtitle class="green-label">{{
                                value.match.competition.name
                              }}</v-list-item-subtitle>
                              <v-list-item-title class="team-names">{{
                                value.match.homeTeam.name
                              }}</v-list-item-title>
                              <v-list-item-title class="team-names">{{
                                value.match.awayTeam.name
                              }}</v-list-item-title>
                              <v-list-item-subtitle class="match-date"
                                >{{ value.match.hour }} .
                                {{ value.match.date }}</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                      </v-row>
                      <!-- tiroCerteiroMarkets -->
                      <v-row class="market-header">
                        <v-col cols="6">
                          <div class="dialog-label">Mercado</div>
                        </v-col>
                        <v-col cols="3">
                          <div class="dialog-label">Prognóstico</div>
                        </v-col>
                        <v-col cols="3">
                          <div class="dialog-label">Resultado</div>
                        </v-col>
                      </v-row>
                      <div
                        v-for="(market, marketId) in value.tiroCerteiroMarkets"
                        :key="'tiroCerteiro-' + marketId"
                      >
                        <v-row
                          class="market-row"
                          v-for="(outcome, outcomeId) in market.outcomes"
                          :key="'tiroCerteiro-' + marketId + outcomeId"
                        >
                          <v-col cols="6">
                            <v-text-field
                              class="dialog-text"
                              dense
                              filled
                              hide-details
                              v-model="market.name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field
                              class="dialog-text"
                              dense
                              filled
                              hide-details
                              v-model="outcome.name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              :items="results"
                              item-text="name"
                              v-model="outcome.result"
                              hide-details
                              background-color="#D8E0E6"
                              color="#9aabb8"
                              solo
                              flat
                              height="32px"
                              :class="
                                outcome.result == 'Certo'
                                  ? 'result-success'
                                  : outcome.result == 'Errado'
                                  ? 'result-fail'
                                  : ''
                              "
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                      <v-divider
                        style="margin-top: 16px; margin-bottom: 8px"
                      ></v-divider>
                      <!-- bigoddsMarkets -->
                      <v-row class="market-header">
                        <v-col cols="6">
                          <div class="dialog-label">Mercado</div>
                        </v-col>
                        <v-col cols="3">
                          <div class="dialog-label">Prognóstico</div>
                        </v-col>
                        <v-col cols="3">
                          <div class="dialog-label">Resultado</div>
                        </v-col>
                      </v-row>
                      <div
                        v-for="(item, index) in value.bigoddsMarkets"
                        :key="'bigodds-' + item.id + index"
                      >
                        <v-row>
                          <v-col cols="6">
                            <v-select
                              :items="markets"
                              item-text="name"
                              return-object
                              v-model="item.market"
                              hide-details
                              background-color="#D8E0E6"
                              color="#9aabb8"
                              solo
                              flat
                              height="32px"
                            ></v-select>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              :items="
                                item.market
                                  ? item.market.outcomes
                                  : item.outcomes
                              "
                              item-text="name"
                              v-model="item.outcome"
                              hide-details
                              background-color="#D8E0E6"
                              color="#9aabb8"
                              solo
                              flat
                              height="32px"
                            ></v-select>
                          </v-col>
                          <v-col cols="3">
                            <v-select
                              :items="results"
                              item-text="name"
                              v-model="item.result"
                              hide-details
                              background-color="#D8E0E6"
                              color="#9aabb8"
                              solo
                              flat
                              height="32px"
                              :class="
                                item.result == 'Certo'
                                  ? 'result-success'
                                  : item.result == 'Errado'
                                  ? 'result-fail'
                                  : ''
                              "
                            ></v-select>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="saveItem(true)"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Match Header -->
      <template v-slot:[`header.matchMarkets`]="{ header }">
        <div
          v-for="(headerItem, index) in header.text.split('>')"
          :key="'th-' + index"
          class="float-left"
          :style="
            index == 0
              ? 'width: 80px;'
              : index == 1
              ? 'width: 200px;'
              : index == 2
              ? 'width: 100px;'
              : index == 3
              ? 'width: 160px;'
              : index == 4
              ? 'width: 140px;'
              : index == 5
              ? 'width: 50px;'
              : index == 6
              ? 'width: 50px;'
              : ''
          "
        >
          {{ headerItem.split("#")[0] }}
        </div>
      </template>
      <!-- Match Row -->
      <template v-slot:[`item.matchMarkets`]="{ item }">
        <div
          v-for="(matchMarket, index) in item.matchMarkets"
          :key="'td-' + index"
          class="prognostic-div"
          style="clear: both"
        >
          <div class="float-left" style="width: 80px">
            {{ matchMarket.match.sport.name }}
          </div>
          <div class="float-left" style="width: 200px">
            {{ matchMarket.match.homeTeam.name }} x
            {{ matchMarket.match.awayTeam.name }}
          </div>
          <div class="float-left" style="width: 100px">
            {{ matchMarket.match.country.name }}
          </div>
          <div class="float-left" style="width: 160px">
            {{ matchMarket.match.competition.name }}
          </div>
          <div class="float-left" style="width: 140px">
            {{ matchMarket.match.date }} | {{ matchMarket.match.hour }}
          </div>
          <div class="float-left" style="width: 50px">
            {{ totalOdd(matchMarket) }}
          </div>
          <div class="float-left" style="width: 50px">
            {{ totalBank(matchMarket) }}%
          </div>
        </div>
      </template>

      <!-- ACTIONS -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          dark
          color="#FFC121"
          @click="closeItem(item)"
          style="margin-right: 8px"
          >Encerrar</v-btn
        >
        <v-btn
          depressed
          dark
          color="#D8E0E6"
          class="gray-button"
          @click="editItem(item)"
          style="margin-right: 8px"
          >Editar</v-btn
        >
        <RemoveItem
          :target="'prognóstico'"
          @remove-item="deleteItem(item)"
        ></RemoveItem>
      </template>
      <!-- FILLERS-->
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - items.length" :key="'footer-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
    <div class="pagination">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<style scoped>
.result-success,
.result-fail {
  border: none !important;
}
.market-header .col {
  padding-bottom: 0;
}
.market-row .col {
  padding: 8px 12px;
}
.team-icon >>> .v-image__image {
  background-size: 32px !important;
}
.team-logos {
  position: relative;
}
.logos-container {
  right: 20px;
}
.v-data-table >>> .v-data-table__wrapper table {
  table-layout: fixed;
}
.prognostic-div:first-child div {
  padding-top: 16px;
  padding-bottom: 8px;
}
.prognostic-div:last-child div {
  padding-top: 8px;
  padding-bottom: 16px;
}
.prognostic-match >>> .v-input__control {
  min-height: 80px !important;
  height: 80px;
}
.prognostic-match.v-input--is-label-active >>> .v-input__slot {
  background-color: #ffffff !important;
}
.prognostic-match >>> .v-select__selections {
  flex-wrap: wrap !important;
}
.prognostic-match >>> .v-select__selections div {
  width: 100%;
}
.prognostic-match >>> .v-select__selections div:nth-child(1) {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 14px;
  color: #9aabb8;
}
.prognostic-match >>> .v-select__selections div:nth-child(2) {
  font-family: Gilroy-Bold;
  font-size: 24px;
  color: #304351;
}
.float-left {
  float: left;
}
.v-input >>> .v-text-field__details {
  padding: 0 !important;
}
.v-input >>> .v-input__control {
  display: table;
}
.error--text {
  font-size: 12px;
  padding: 0;
}
@media only screen and (max-width: 1024px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 1180px;
  }
}
</style>

<script>
import Vue from "vue";
import RemoveItem from "@/components/RemoveItem";

import ApiService from "../../services/api.service";

export default Vue.extend({
  name: "PrognosticsTable",
  components: {
    RemoveItem,
  },
  props: { data: {} },
  data: () => ({
    sportsList: ["Modalidade", "Futebol", "Ténis", "Basquetebol"],
    countriesList: ["País", "Portugal", "Espanha", "Inglaterra"],
    selectedSport: "Modalidade",
    selectedCountry: "País",
    dialog: false,
    closePrognostic: false,
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    headers: [
      {
        text: "Modalidade>Jogos>Pais>Competição>Data|Hora>Odd>Banca",
        value: "matchMarkets",
        width: "820px",
        sortable: false,
      },
      { text: "Tiro Certeiro", value: "tiroCerteiro", sortable: false },
      {
        text: "",
        align: "end",
        value: "actions",
        width: "250px",
        sortable: false,
      },
    ],
    items: [],
    results: ["Certo", "Errado", "Void"],
    sports: [],
    countries: [],
    competitions: [],
    matches: [],
    markets: [],
    totalItems: 0,
    dialogTitle: "",
    tempItem: {},
    editedItem: {
      id: "",
      matchMarkets: {},
      odd: "",
      bank: "",
      tiroCerteiro: false,
      status: null,
    },
    simpleItem: {
      id: "",
      matchMarkets: [
        {
          match: {
            id: "",
            sport: "",
            country: "",
            competition: "",
          },
          tiroCerteiroMarkets: [],
          bigoddsMarkets: [],
        },
      ],
      odd: "",
      bank: "",
      tiroCerteiro: false,
      status: null,
    },
    multipleItem: {
      id: "",
      matchMarkets: [
        {
          match: {
            id: "",
            sport: "",
            country: "",
            competition: "",
          },
          tiroCerteiroMarkets: [],
          bigoddsMarkets: [],
        },
        {
          match: {
            id: "",
            sport: "",
            country: "",
            competition: "",
          },
          tiroCerteiroMarkets: [],
          bigoddsMarkets: [],
        },
      ],
      odd: "",
      bank: "",
      tiroCerteiro: false,
      status: null,
    },
    matchMarket: {
      match: {
        id: "",
        sport: "",
        country: "",
        competition: "",
      },
      tiroCerteiroMarkets: [],
      bigoddsMarkets: [],
    },
    isMultiple: false,
    input: {
      country: [
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
      ],
      sport: [
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
      ],
      competition: [
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
      ],
      match: [
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
        {
          value: "",
          valid: false,
          error: false,
          errorText: "",
        },
      ],
    },
  }),
  created() {
    this.getFrontendLists();
  },
  mounted() {
    this.getItems(0, this.itemsPerPage);
  },
  methods: {
    getFrontendLists() {
      ApiService.getGraphQLFrontendLists().then(
        (response) => {
          const data = response.data.data.getCountriesAndSports;
          this.sports = data.sports;
          // Push 'Futebol' to first position
          data.sports.sort(function (x, y) {
            return x.name == "Futebol" ? -1 : y.name == "Futebol" ? 1 : 0;
          });

          Vue.set(this, "sports", data.sports);
          this.countries = data.countries;
          Vue.set(this, "countries", data.countries);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getCompetitionList(country, sport, index) {
      this.loading = true;
      ApiService.getGraphQLCompetitionList(country, sport).then(
        (response) => {
          this.competitions[index] =
            response.data.data.getCompetitionsByCountryAndSport;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getMatchesList(competition, index) {
      this.loading = true;
      ApiService.getGraphQLMatchesList(competition).then(
        (response) => {
          //this.matches[index] = response.data.data.getMatchesByCompetition;
          Vue.set(
            this.matches,
            index,
            response.data.data.getMatchesByCompetition
          );
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getMarketsList(sport) {
      this.loading = true;
      ApiService.getGraphQLMarketsList(sport).then(
        (response) => {
          this.markets = response.data.data.getMarketsBySportId;
          Vue.set(this, "markets", response.data.data.getMarketsBySportId);
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getItems(page, size) {
      this.loading = true;
      ApiService.getAdminGraphQLPrognostics(this.search, page, size).then(
        (response) => {
          const data = response.data.data.getPrognosticsByText;
          this.items = data.prognostics;
          this.totalItems = data.totalElements;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    requestPage(page) {
      this.getItems(page - 1, this.itemsPerPage);
    },
    saveItem(close) {
      this.loading = true;

      if (close) {
        this.editedItem.status = "CLOSED";
        ApiService.closePrognoctic(this.editedItem).then(
          (response) => {
            this.dialog = false;
            this.closePrognostic = false;
            this.loading = false;
            this.getItems(this.page - 1, this.itemsPerPage);
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      } else {
        ApiService.savePrognoctic(this.editedItem).then(
          (response) => {
            this.dialog = false;
            this.closePrognostic = false;
            this.loading = false;
            this.getItems(this.page - 1, this.itemsPerPage);
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      }
    },
    deleteItem(item) {
      this.loading = true;
      ApiService.deletePrognostic(item.id).then(
        (response) => {
          console.log(response.data);
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    closeItem(item) {
      //console.log(item.matchMarkets[0].match.sport)
      this.getMarketsList(item.matchMarkets[0].match.sport);
      this.editedItem = this.$lodash.cloneDeep(item);
      this.closePrognostic = true;
    },
    editItem(item) {
      this.dialogTitle = "Editar prognóstico";
      this.editedItem = this.$lodash.cloneDeep(item);
      this.tempItem = this.$lodash.cloneDeep(this.editedItem);
      this.isMultiple = item.matchMarkets.length > 1;

      for (let i = 0; i < item.matchMarkets.length; i++) {
        const match = item.matchMarkets[i].match;
        console.log(match);
        this.getCompetitionList(match.country, match.sport, i);
        this.getMatchesList(match.competition, i);
        this.getMarketsList(match.sport);
      }

      this.dialog = true;
    },
    addMarket(bigoddsMarkets) {
      bigoddsMarkets.push({});
    },
    setMultiple() {
      if (this.isMultiple) {
        if (this.tempItem.matchMarkets) {
          const multiple = this.$lodash.cloneDeep(this.multipleItem);
          for (let i = 0; i < this.tempItem.matchMarkets.length; i++) {
            Vue.set(
              multiple.matchMarkets,
              i,
              this.$lodash.cloneDeep(this.tempItem.matchMarkets[i])
            );
            this.editedItem = this.$lodash.cloneDeep(multiple);
          }
        } else {
          this.editedItem.matchMarkets.push(
            this.$lodash.cloneDeep(this.matchMarket)
          );
        }
      } else {
        this.editedItem.matchMarkets.pop();
      }
    },
    updateCompetitionsAndMarkets(country, sport, index) {
      this.getMarketsList(sport);
      this.getCompetitionList(country, sport, index);
    },
    totalBank(market) {
      let total = 0;
      if (market.bigoddsMarkets) {
        market.bigoddsMarkets.forEach((item) => {
          total += item.bank;
        });
      }
      return total;
    },
    totalOdd(market) {
      let total = 0;
      if (market.bigoddsMarkets) {
        market.bigoddsMarkets.forEach((item) => {
          //total = total * item.odd;
          total == 0 ? (total = 1 * item.odd) : (total = total * item.odd);
        });
      }
      return total.toFixed(2);
    },
    validate() {
      const validCountry = this.validateArray(
        "country",
        this.input.country,
        true
      );
      const validSport = this.validateArray("sport", this.input.sport, true);
      const validCompetition = this.validateArray(
        "competition",
        this.input.competition,
        true
      );
      const validMatch = this.validateArray("id", this.input.match, true);

      if (validCountry && validSport && validCompetition && validMatch) {
        this.saveItem();
      }
    },
    validateInput(item, input, fromButton) {
      if (item != "") {
        input.valid = true;
        input.error = false;
        input.errorText = null;
        return true;
      } else {
        input.valid = false;
        if (fromButton) {
          input.error = true;
          input.errorText = "Campo obrigatório!";
        }
        return false;
      }
    },
    validateArray(key, input, fromButton) {
      let i = 0;
      let result = true;

      this.editedItem.matchMarkets.forEach((item) => {
        if (item.match[key] != "") {
          input[i].valid = true;
          input[i].error = false;
          input[i].errorText = null;
          result = result && true;
        } else {
          input[i].valid = false;
          if (fromButton) {
            input[i].error = true;
            input[i].errorText = "Campo obrigatório!";
          }
          result = result && false;
        }
        i++;
      });
      return result;
    },
    clearValidation() {
      Object.keys(this.input).forEach((key) => {
        this.input[key][0].value = "";
        this.input[key][1].value = "";
        this.input[key][0].valid = false;
        this.input[key][1].valid = false;
        this.input[key][0].error = false;
        this.input[key][1].error = false;
        this.input[key][0].errorText = false;
        this.input[key][1].errorText = false;
      });
    },
  },
});
</script>